var styles = {
  "separator": "_separator_4ia7vb_3",
  "light": "_light_4ia7vb_22",
  "dark": "_dark_4ia7vb_28"
};
export { styles as default };
